"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
    Map
    
    All map related translations
    
    Verified by: Cédric Bloem
    Date: 12/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
var MapData = {
  location: {
    nl: 'Locatie',
    fr: 'Emplacement',
    en: 'Location'
  },
  nis: {
    nl: 'NIS',
    fr: 'INS',
    en: 'NIS'
  },
  nis_type: {
    nl: 'NIS type',
    fr: 'Type INS',
    en: 'NIS type'
  },
  nis_types: {
    nl: 'NIS types',
    fr: 'Types d\'INS',
    en: 'NIS types'
  },
  nis_upper: {
    nl: 'Bovenliggende NIS',
    fr: 'Parent INS',
    en: 'NIS parent'
  },
  nis_adjacent: {
    nl: 'Aangrenzende NIS',
    fr: 'INS adjecente',
    en: 'Adjacent NIS'
  },
  alternative_street_translations: {
    nl: 'Alternatieve straat',
    fr: 'Rue alternative',
    en: 'Alternative street'
  },
  extra_location_info: {
    nl: 'Extra locatie info',
    fr: 'Extra information sur l\'emplacement',
    en: 'Extra location info'
  },
  extra_info: {
    nl: 'Extra info',
    fr: 'Extra information',
    en: 'Extra info'
  },
  from_nr: {
    nl: 'Van (nr.)',
    fr: 'De (n°)',
    en: 'From (nr.)'
  },
  to_nr: {
    nl: 'Tot (nr.)',
    fr: 'À (n°)',
    en: 'To (nr.)'
  },
  is_even_nr: {
    nl: 'Even nummer',
    fr: 'Nombre pair',
    en: 'Even number'
  },
  country: {
    nl: 'Land',
    fr: 'Pays',
    en: 'Country'
  },
  flag: {
    nl: 'Vlag',
    fr: 'Drapeau',
    en: 'Flag'
  },
  flags: {
    nl: 'Vlaggen',
    fr: 'Drapeaux',
    en: 'Flags'
  },
  coat_of_arms: {
    nl: 'Wapenschild',
    fr: 'Armoiries',
    en: 'Coat of Arms'
  },
  region: {
    nl: 'Gewest',
    fr: 'Région',
    en: 'Region'
  },
  regions: {
    nl: 'Gewesten',
    fr: 'Régions',
    en: 'Regions'
  },
  province: {
    nl: 'Provincie',
    fr: 'Province',
    en: 'Province'
  },
  provinces: {
    nl: 'Provincies',
    fr: 'Provinces',
    en: 'Provinces'
  },
  district: {
    nl: 'Arrondissement',
    fr: 'District',
    en: 'District'
  },
  postal_code: {
    nl: 'Postcode',
    fr: 'Code postal',
    en: 'Postalcode'
  },
  postalcode: {
    nl: 'Postcode',
    fr: 'Code postal',
    en: 'Postalcode'
  },
  municipality: {
    nl: 'Gemeente',
    fr: 'Commune',
    en: 'Municipality'
  },
  municipality_name: {
    nl: 'Gemeentenaam',
    fr: 'Nom d\'commune',
    en: 'Municipality name'
  },
  municipalities: {
    nl: 'Gemeenten',
    fr: 'Municipalités',
    en: 'Municipalities'
  },
  sub_municipality: {
    nl: 'Deelgemeente',
    fr: 'Sous-municipalité',
    en: 'Sub municipality'
  },
  sub_municipalities: {
    nl: 'Deelgemeenten',
    fr: 'Sous-municipalités',
    en: 'Sub municipalities'
  },
  neighborhood: {
    nl: 'Wijk',
    fr: 'Quartier',
    en: 'Neighborhood'
  },
  street: {
    nl: 'Straat',
    fr: 'Rue',
    en: 'Street'
  },
  streets: {
    nl: 'Straten',
    fr: 'Rues',
    en: 'Streets'
  },
  streetcode: {
    nl: 'Straat code',
    fr: 'Code d\'rue',
    en: 'Street code'
  },
  street_name: {
    nl: 'Straatnaam',
    fr: 'Nom rue',
    en: 'Street name'
  },
  official_street_name: {
    nl: 'Officiële straatnaam',
    fr: 'Nom officiel de la rue',
    en: 'Official street name'
  },
  alternative_street_name: {
    nl: 'Alt. straatnaam',
    fr: 'Nom alt. de la rue',
    en: 'Alt. street name'
  },
  street_data: {
    nl: 'Straat data',
    fr: 'Données de rue',
    en: 'Street data'
  },
  street_name_id: {
    nl: 'Straatnaam ID',
    fr: 'ID nom rue',
    en: 'Street name ID'
  },
  streetnmid: {
    nl: 'Straatnaam ID',
    fr: 'ID nom rue',
    en: 'Street name ID'
  },
  street_code: {
    nl: 'Straat code',
    fr: 'Code rue',
    en: 'Street code'
  },
  enterance_at: {
    nl: 'Toegang via',
    fr: 'Entrée à',
    en: 'Entrance at'
  },
  no: {
    nl: 'Nr.',
    fr: 'No.',
    en: 'No.'
  },
  box: {
    nl: 'Box Nr.',
    fr: 'Box No.',
    en: 'Box No.'
  },
  address_info: {
    nl: 'Adres informatie',
    fr: "Information d'addresse",
    en: 'Address information'
  },
  longitude: {
    nl: 'Lengtegraad',
    fr: 'Longitude',
    en: 'Longitude'
  },
  latitude: {
    nl: 'Breedtegraad',
    fr: 'Latitude',
    en: 'Latitude'
  },
  current_map_view: {
    nl: 'Huidige kaart weergave:',
    fr: "Vue d'carte actuelle",
    en: 'Current map view'
  },
  view: {
    nl: 'Weergave',
    fr: 'Vue',
    en: 'View'
  },
  map_instructions: {
    nl: "Klik op 1 van de volgende niveaus om een ondernemer, die zijn diensten/producten aanbiedt, terug te vinden. \n                Op (deel)gemeente niveau garanderen wij u een weergave van alle beschikbare ondernemingen. \n                Vanaf provincie niveau gaat het om ondernemingen die commercieel ingeschreven zijn.\n\n                De niveaus zijn:",
    fr: "Cliquez sur un des niveaux suivants pour trouver un entrepreneur qui offre ses services / produits. \n                Au niveau des (sous) municipalit\xE9s, nous vous garantissons une repr\xE9sentation de toutes les entreprises disponibles. \n                Au niveau de la province, il s\u2019agit des entreprises inscrit commercialement.\n                \n                Les niveaux sont:",
    en: "Click on 1 of the following levels to find an entrepreneur who offers his services / products. \n                At (sub) municipality level we guarantee you a representation of all available companies. \n                From the province level it concerns companies that have signed up commercially.\n                \n                The levels are:"
  },
  link_adress: {
    nl: 'Link naar adresinformatie',
    fr: "Lien vers les informations sur l'adresse",
    en: 'Link to address information'
  },
  hierarchical_niscode: {
    nl: 'Hiërarchische NIS-code',
    fr: 'Code INS hiérarchique',
    en: 'Hierarchical NIS-code'
  },
  historical_niscode: {
    nl: 'Historische NIS-code',
    fr: 'Code INS historique',
    en: 'Historic NIS-code'
  },
  country_id: {
    nl: 'Land ID',
    fr: 'ID de Pays',
    en: 'Country ID'
  },
  nis_type_id: {
    nl: 'NIS type ID',
    fr: 'ID types d\'INS',
    en: 'NIS type ID'
  },
  nis_type_name: {
    nl: 'NIS type naam',
    fr: 'Nom de types d\'INS',
    en: 'NIS type name'
  }
};
var _default = MapData;
exports["default"] = _default;